import { RelationshipStatus } from '../models/enum/shared/relationship-status';

export class RelationshipStatusUtils {
  private static readonly PARTNERED_STATUSES = new Set<RelationshipStatus>([
    RelationshipStatus.Married,
    RelationshipStatus.CommonLaw,
    RelationshipStatus.Divorced,
    RelationshipStatus.Separated
  ]);

  private static readonly PARTNERED_STATUSES_FOR_DISPLAY = new Set<RelationshipStatus>([
    RelationshipStatus.Married,
    RelationshipStatus.CommonLaw,
    RelationshipStatus.Separated
  ]);

  static isPartneredStatus(status: RelationshipStatus | null): boolean {
    if (status === null) return false;
    return this.PARTNERED_STATUSES.has(status);
  }

  static isPartneredStatusForDisplay(status: RelationshipStatus | null): boolean {
    if (status === null) return false;
    return this.PARTNERED_STATUSES_FOR_DISPLAY.has(status);
  }

  static getRelationshipStartDateLabel(typeId: RelationshipStatus | null): string {
    if (typeId === RelationshipStatus.CommonLaw) {
      return $localize`Relationship Cohabitation Date`;
    } else {
      return $localize`Relationship Effective Date`;
    }
  }

  static getRelationshipFileUploadLabel(typeId: RelationshipStatus): string {
    const labelMap: Partial<Record<RelationshipStatus, string>> = {
      [RelationshipStatus.CommonLaw]: $localize`Declaration of Common-Law Union`,
      [RelationshipStatus.Married]: $localize`Marriage Certificate`,
      [RelationshipStatus.Widowed]: $localize`Death Certificate`,
      [RelationshipStatus.Divorced]: $localize`Divorce Certificate`,
      [RelationshipStatus.Separated]: $localize`Separation Agreement`
    };

    return labelMap[typeId] ?? $localize`Relevant Documentation`;
  }

  static getRelationshipFileUploadCopy(typeId: RelationshipStatus): string {
    const labelMap: Partial<Record<RelationshipStatus, string>> = {
      [RelationshipStatus.Single]: $localize`Additional supporting documents from the original request may be uploaded, if applicable.`,
      [RelationshipStatus.CommonLaw]: $localize`A Declaration of Common-Law Union is optional. Additional supporting documents from the original request may be uploaded as well, if applicable.`,
      [RelationshipStatus.Married]: $localize`A Marriage Certificate upload is required. Additional supporting documents from the original request may be uploaded as well, if applicable. `,
      [RelationshipStatus.Widowed]: $localize`A Death Certificate is required. Additional supporting documents from the original request may be uploaded as well, if applicable.`,
      [RelationshipStatus.Divorced]: $localize`A Divorce Certificate is required. Additional supporting documents from the original request may be uploaded as well, if applicable.`,
      [RelationshipStatus.Separated]: $localize`A Separation Agreement is an optional upload. Additional supporting documents from the original request may be uploaded as well, if applicable.`
    };

    return labelMap[typeId] ?? '';
  }
}
